import SCORE_CONFIG from "assets/configs/score"

const colors = {
  orange: SCORE_CONFIG.common.colorsEvaluation.yellow,
  green: SCORE_CONFIG.common.colorsEvaluation.green,
  red: SCORE_CONFIG.common.colorsEvaluation.red,
  yellow: SCORE_CONFIG.common.colorsEvaluation.yellow2,
  grey: SCORE_CONFIG.common.disabledColor,
}

export const getCompareWithPreviousBarColors = (
  data,
  firstColumnAlwaysGrey = false
) => {
  return data.map((value, index) => {
    value = Number(value)

    if (firstColumnAlwaysGrey && index === 0) return colors.grey

    if (index === 0) return colors.orange

    const previousValue = Number(data[index - 1])

    if (value < previousValue) return colors.green
    if (value > previousValue) return colors.red
    return colors.orange
  })
}
